/* src/app/location-users/user-sort/user-sort.component.scss */
.users-sort .sort-controls {
  display: flex;
  flex-direction: row;
}
.users-sort .sort-controls ups-select {
  width: 250px;
}
.users-sort .up-and-down-sort {
  box-shadow: none;
  background-color: white;
  border: thin #757575 solid;
  margin-left: 10px;
}
.users-sort .up-and-down-sort:before {
  font-family: upsicons, fantasy !important;
  content: "\e619" !important;
}
/*# sourceMappingURL=user-sort.component.css.map */
